import React, { Fragment } from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import LogoHeader from "./LogoHeader";
const AdvancesMainHeaderOne = ({ data }) => {
  const styles = StyleSheet.create({
    MainContainer: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    CompanyHeader: {
      fontSize: "17px",
      fontWeight: 600,
      color: "#4B5660",
    },
    subHeaderContainer: {
      width: "100%",
      flexDirection: "column",
      alignItems: "flex-end",
    },
    IDContainer: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    subHeaderID: {
      fontSize: "11px",
      fontWeight: "500",
      color: "#00000099",
      opacity: "0.5",
      marginRight: "10px",
    },
    subHeaderIDValue: {
      fontSize: "10px",
      fontWeight: "500",
      color: "#141414F4",
    },

    amountHeader: {
      fontSize: "11px",
      fontWeight: "900",
      color: "#4E4E4E",
    },
    amount: {
      fontSize: "17px",
      fontWeight: "900",
      color: "#4B5660",
    },
  });
  return (
    <Fragment>
      <LogoHeader />
      <View style={styles.MainContainer}>
        <Text style={styles.CompanyHeader}>
          {data?.pdf_details?.advance_number
            ? data?.pdf_details?.advance_number
            : "-"}
        </Text>
        <Text style={styles.CompanyHeader}>{data?.title}</Text>
      </View>
      <View style={styles.IDContainer}>
        <Text style={styles.subHeaderID}>Advance ID</Text>
        <Text style={styles.subHeaderIDValue}>
          {data?.advance_number ? data?.advance_number : "-"}
        </Text>
      </View>
      <View style={styles.subHeaderContainer}>
        <Text style={styles.amountHeader}>Advance Amount</Text>
        <Text style={styles.amount}>
          INR {data?.approved_amount ? data?.approved_amount : "-"}
        </Text>
      </View>
    </Fragment>
  );
};

export default AdvancesMainHeaderOne;
